const translation = {
  // Navbar
  nav_home: 'Inicio',
  nav_destinations: 'Destinos',
  nav_gallery: 'Galería',
  nav_offers: 'IAEE 2026 CHILE',
  nav_testimonials: 'Testimonios',
  nav_contact: 'Contacto',
  nav_assistant: 'Asistente',

  // Hero
  hero_title: 'Descubre Chile con GaLi Travel',
  hero_subtitle: 'Tu aventura comienza aquí',
  hero_cta: 'Explorar Destinos',

  // Destinations
  dest_title: 'Destinos Imperdibles',
  dest_subtitle: 'Desde el árido Desierto de Atacama hasta los glaciares de la Patagonia, Chile ofrece una diversidad única de paisajes y experiencias inolvidables.',
  dest_see_more: 'Ver más',

  // Offers
  offers_badge: 'OFERTAS EXCLUSIVAS',
  offers_title: 'Viaja Más,\nGasta Menos',
  offers_subtitle: 'Aprovecha nuestras promociones especiales y descubre Chile a los mejores precios. Paquetes diseñados para que vivas experiencias únicas sin comprometer tu presupuesto.',
  offers_see_all: 'Ver Todas las Ofertas',
  offers_valid_until: 'Válido hasta',
  offers_book_now: 'Reservar Ahora',

  // Testimonials
  test_title: 'Lo Que Dicen Nuestros Viajeros',

  // Contact
  contact_title: 'Planifica Tu Próximo Viaje',
  contact_subtitle: 'Completa el formulario y nos pondremos en contacto contigo',
  contact_name: 'Nombre Completo',
  contact_name_placeholder: 'Tu nombre',
  contact_email: 'Correo Electrónico',
  contact_phone: 'Teléfono',
  contact_phone_placeholder: '+56 9 1234 5678',
  contact_destination: 'Destino',
  contact_destination_select: 'Seleccionar',
  contact_date: 'Fecha de Viaje',
  contact_travelers: 'Número de Viajeros',
  contact_person: 'persona',
  contact_persons: 'personas',
  contact_message: 'Mensaje',
  contact_message_placeholder: 'Cuéntanos sobre tu viaje ideal...',
  contact_chars: 'caracteres',
  contact_submit: 'Enviar Solicitud',
  contact_submitting: 'Enviando...',
  contact_success: '¡Mensaje enviado con éxito! Nos pondremos en contacto pronto.',
  contact_error: 'Hubo un error al enviar el mensaje. Por favor intenta de nuevo.',
  contact_phone_label: 'Teléfono',
  contact_email_label: 'Correo',
  contact_whatsapp: 'WhatsApp',
  contact_whatsapp_available: 'Disponible 24/7',
  contact_hours: 'Horario de Atención',
  contact_hours_weekdays: 'Lunes a Viernes: 9:00 - 19:00',
  contact_hours_saturday: 'Sábado: 10:00 - 14:00',
  contact_quick_response: 'Respuesta Rápida',
  contact_quick_response_text: 'Respondemos todas las consultas en menos de 24 horas',

  // Footer
  footer_about: 'Sobre Nosotros',
  footer_our_story: 'Nuestra Historia',
  footer_team: 'Equipo',
  footer_values: 'Valores',
  footer_work_with_us: 'Trabaja con Nosotros',
  footer_popular_dest: 'Destinos Populares',
  footer_resources: 'Recursos',
  footer_travel_blog: 'Blog de Viajes',
  footer_destination_guides: 'Guías de Destinos',
  footer_travel_tips: 'Consejos de Viaje',
  footer_faq: 'Preguntas Frecuentes',
  footer_contact: 'Contacto',
  footer_rights: '© 2024 GaLi Travel Chile. Todos los derechos reservados.',
  footer_terms: 'Términos y Condiciones',
  footer_privacy: 'Privacidad',
  footer_cert_sernatur: 'Certificado Sernatur',
  footer_cert_safe: 'Turismo Seguro',
};

export default translation;
